import React from 'react';
import { Wrapper, RemoveButton, getColor } from './tag.style';
import { TagProps, TagStyles } from './tag.types';
import { useTheme } from 'styled-components';
import { ButtonStyles } from '../Button/button.types';

const Tag = ({
  label = '',
  color = TagStyles.DEFAULT,
  hasRemoveButton,
  children,
  handlers,
  ariaLabel,
  className,
  highlightColor = false,
  dataAttr,
}: TagProps) => {
  const theme = useTheme();
  const content = label || (children as string);
  let removeBtn = null;

  if (hasRemoveButton) {
    removeBtn = (
      <RemoveButton
        iconSize={8}
        iconColor={getColor(theme, color, highlightColor).color}
        hasHover={false}
        iconName={'close'}
        ariaLabel={ariaLabel || content}
        handlers={handlers}
        styleName={color as unknown as ButtonStyles}
      />
    );
  }

  return (
    <Wrapper
      className={className}
      color={color}
      hasRemoveButton={hasRemoveButton}
      highlightColor={highlightColor}
      {...dataAttr}
    >
      {content}
      {removeBtn}
    </Wrapper>
  );
};

export default Tag;
